



























































import {Component, Prop, Vue} from 'vue-property-decorator'
import spacetime, {Spacetime} from "spacetime";

type GenericTaxQuestionType = 'yes_no' | 'amount' | 'string' | 'date' | 'number';

interface GenericTaxQuestion<T> {
    questionType: GenericTaxQuestionType;
    label: string;
    tooltip?: string;
    valueName: string;
    value: T;
    dependsOnValue?: string; // a yes_no question that needs to be set to "yes" in order for this question to appear
}

@Component
export default class GenericTaxDetailsForm extends Vue {

    @Prop()
    questions!: GenericTaxQuestion<any>[];

    @Prop()
    formEndpoint!: string;

    @Prop()
    previousStepHref!: string;

    private nonPropQuestions = this.questions;
    private loading: boolean = false;

    private mounted() {
        for (const question of this.questions) {
            if (question.questionType === 'date' && question.value) {
                question.value = spacetime(question.value);
            }
        }
    }

    private get questionsToShow(): GenericTaxQuestion<any>[] {
        return this.nonPropQuestions.filter(question => {
            return this.canShowQuestion(question);
        });
    }

    private canShowQuestion(question: GenericTaxQuestion<any>): boolean {
        const dependsOnValue = question.dependsOnValue;
        if (dependsOnValue) {
            const dependantQuestion = this.questions.find(q => q.valueName === dependsOnValue);
            if (dependantQuestion) {
                return dependantQuestion.value === true && this.canShowQuestion(dependantQuestion);
            }
        }

        return true;
    }

}
